import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.min.css'
import validator from 'validator';


export default { 
  ValidateForm(form,message){
    if(!form.name || validator.isEmpty(form.name)){
      toast.warning("Name is empty!")
      return false
    }
    
    else if(!form.phone || !validator.isMobilePhone(form.phone, 'any')) {
      toast.warning("Phone number is Invalid!")
      return false
    }
    
    else if(validator.isEmpty(form.email)) {
      toast.warning("Email address is empty!")
      return false
    }

    else if(!validator.isEmail(form.email)) {
      toast.warning("Email address is Invalid!")
      return false
    }

    return true
  },
}



// WEBPACK FOOTER //
// ./src/App/master/contact/helper/form.js